import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Link } from "react-router-dom";
import { ListChecks, Users, Sparkles } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ quizzes: 0, participations: 0 });

  useEffect(() => {
    api.get("/admin/quizzes").then((r) => setStats((s) => ({ ...s, quizzes: (r.data || []).length })));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-outfit text-3xl font-bold text-[#0B1D3A] mb-2">Dashboard</h1>
      <p className="text-[#0B1D3A]/60 mb-8">Visão geral do NATALMÁTICO</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <Link to="/admin/quizzes" className="rounded-2xl bg-white p-6 border border-[#0B1D3A]/5 hover:border-[#FF6B6B] transition">
          <ListChecks className="text-[#FF6B6B]" />
          <p className="text-3xl font-outfit font-bold mt-3 text-[#0B1D3A]">{stats.quizzes}</p>
          <p className="text-sm text-[#0B1D3A]/60">Quizzes criados</p>
        </Link>
        <Link to="/admin/settings" className="rounded-2xl bg-white p-6 border border-[#0B1D3A]/5 hover:border-[#005F73] transition">
          <Sparkles className="text-[#005F73]" />
          <p className="font-outfit font-bold mt-3 text-[#0B1D3A]">Efeitos</p>
          <p className="text-sm text-[#0B1D3A]/60">Neve, confetis, luzes</p>
        </Link>
        <Link to="/admin/texts" className="rounded-2xl bg-white p-6 border border-[#0B1D3A]/5 hover:border-[#FFD93D] transition">
          <Users className="text-[#2D6A4F]" />
          <p className="font-outfit font-bold mt-3 text-[#0B1D3A]">Textos PT/EN</p>
          <p className="text-sm text-[#0B1D3A]/60">Editar conteúdos do site</p>
        </Link>
      </div>
    </div>
  );
}
